import { useContext } from "react";

import { AuthUserContext } from ".";

export function useAuth() {
  return useContext(AuthUserContext);
}
